import { render } from "./StockTakeDetails.vue?vue&type=template&id=51cd2e6a"
import script from "./StockTakeDetails.vue?vue&type=script&lang=js"
export * from "./StockTakeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__